export const TYPES = {
  GENERIC_REQUEST: 'GENERIC_REQUEST',
  GENERIC_ERROR: 'GENERIC_ERROR',
  FETCH_ORDER_SUCCESS: 'FETCH_ORDER_SUCCESS',
  UPDATE_ADDRESS_SUCCESS: 'UPDATE_ADDRESS_SUCCESS',
  RECHARGE_SUCCESS: 'RECHARGE_SUCCESS',
  CREATE_OPEN_ENDED_ORDER_SUCCESS: 'CREATE_OPEN_ENDED_ORDER_SUCCESS',
};

export default {
  [TYPES.GENERIC_REQUEST](state, type) {
    const currentState = state;
    currentState[type].loading = true;
    currentState[type].successMessage = '';
    currentState[type].errorMessage = '';
  },
  [TYPES.GENERIC_ERROR](state, errorInfo) {
    const currentState = state;
    currentState[errorInfo.type].errorMessage = errorInfo.message;
    currentState[errorInfo.type].successMessage = '';
    currentState[errorInfo.type].loading = false;
  },
  // eslint-disable-next-line
  [TYPES.FETCH_ORDER_SUCCESS](state, { order, customer, client_settings, }) {
    const currentState = state;
    currentState.orderDetails.order = order;
    // eslint-disable-next-line camelcase
    currentState.orderDetails.clientSettings = client_settings;
    currentState.orderDetails.customerInfo = customer;
    currentState.orderDetails.errorMessage = '';
    currentState.orderDetails.loading = false;
  },
  [TYPES.UPDATE_ADDRESS_SUCCESS](state, data) {
    const currentState = state;
    currentState.addressDetails.data = data;
    currentState.addressDetails.customer = data.customer;
    currentState.addressDetails.items = data.items;
    currentState.addressDetails.policies = data.policies;
    currentState.addressDetails.symbol = data.symbol;
    currentState.addressDetails.orderNumber = data.order_number;
    currentState.addressDetails.requiresPayment = data.requires_payment;
    currentState.addressDetails.errorMessage = '';
    currentState.addressDetails.successMessage = '';
    currentState.addressDetails.loading = false;
  },
  [TYPES.RECHARGE_SUCCESS](state, confirmationId) {
    const currentState = state;
    currentState.recharge.id = confirmationId;
    currentState.recharge.errorMessage = '';
    currentState.recharge.successMessage = '';
    currentState.recharge.loading = false;
  },
  [TYPES.CREATE_OPEN_ENDED_ORDER_SUCCESS](state, data) {
    const currentState = state;
    currentState.openEndedDetails.data = data;
    currentState.openEndedDetails.errorMessage = '';
    currentState.openEndedDetails.successMessage = '';
    currentState.openEndedDetails.loading = false;
  },
};
